export const archiveOption = [
	{ key: "Texto", text: "Texto", value: "Text" },
	{ key: "Imagen", text: "Imagen", value: "Image" },
	{ key: "Archivo", text: "Archivo", value: "Document" },
];

export const boolOnline = [
	{ key: "Activo", text: "Activo", value: true },
	{ key: "Inactivo", text: "Inactivo", value: false },
];
